export default {
  methods: {
    getDateISO(date) {
      return (date instanceof Date) ? date.toISOString().substring(0, 10) : null;
    },
    getDateTimeISO(date) {
      return (date instanceof Date) ? date.toISOString().replace('T', ' ').substring(0, 19) : null;
    },
  },
};
